/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface Practitioner
 */
export interface Practitioner {
    /**
     *
     * @type {string}
     * @memberof Practitioner
     */
    id: string;
    /**
     *
     * @type {string}
     * @memberof Practitioner
     */
    first_name: string;
    /**
     *
     * @type {string}
     * @memberof Practitioner
     */
    last_name: string;
    /**
     *
     * @type {string}
     * @memberof Practitioner
     */
    npi: string | null;
    /**
     *
     * @type {string}
     * @memberof Practitioner
     */
    credential?: string | null;
    /**
     *
     * @type {string}
     * @memberof Practitioner
     */
    address_line?: string | null;
    /**
     *
     * @type {string}
     * @memberof Practitioner
     */
    city?: string | null;
    /**
     *
     * @type {string}
     * @memberof Practitioner
     */
    state?: string | null;
    /**
     *
     * @type {string}
     * @memberof Practitioner
     */
    zip?: string | null;
}

/**
 * Check if a given object implements the Practitioner interface.
 */
export function instanceOfPractitioner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "first_name" in value;
    isInstance = isInstance && "last_name" in value;
    isInstance = isInstance && "npi" in value;

    return isInstance;
}

export function PractitionerFromJSON(json: any): Practitioner {
    return PractitionerFromJSONTyped(json, false);
}

export function PractitionerFromJSONTyped(json: any, ignoreDiscriminator: boolean): Practitioner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'id': json['id'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'npi': json['npi'],
        'credential': !exists(json, 'credential') ? undefined : json['credential'],
        'address_line': !exists(json, 'address_line') ? undefined : json['address_line'],
        'city': !exists(json, 'city') ? undefined : json['city'],
        'state': !exists(json, 'state') ? undefined : json['state'],
        'zip': !exists(json, 'zip') ? undefined : json['zip'],
    };
}

export function PractitionerToJSON(value?: Practitioner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'id': value.id,
        'first_name': value.first_name,
        'last_name': value.last_name,
        'npi': value.npi,
        'credential': value.credential,
        'address_line': value.address_line,
        'city': value.city,
        'state': value.state,
        'zip': value.zip,
    };
}
